{
  "version": 1,
  "asset_id": "bd8b71e3-b356-4c0f-a1f6-7bcf171cba79",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/bd8b71e3-b356-4c0f-a1f6-7bcf171cba79/sylwia-czerwony-garnitur.webp",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/bd8b71e3-b356-4c0f-a1f6-7bcf171cba79/sylwia-czerwony-garnitur.webp",
  "original_filename": "sylwia-czerwony-garnitur.webp",
  "size": 81784,
  "content_type": "image/webp",
  "created_at": "2026-09-30T12:03:19Z"
}
